import { LinkPillReadOnly, type PillLink } from '@/components/EditorPill'
import { useBylineOrganisation } from '@/hooks/useBylineOrganisation'
import { UserPlusIcon } from '@ttab/elephant-ui/icons'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { creditsOrganisation } from './lib/bylineCredit'

/**
 * Read-only byline for documents with no Yjs document to read from, such as
 * the frozen `usable`/`withheld`/`used` snapshot rendered by PlainEditor.
 * Sourced from the fetched document snapshot instead of `useYValue`.
 */
export const EditorBylineReadOnly = ({ authors, credit }: {
  authors: PillLink[] | undefined
  credit?: Array<{ value?: string }>
}): JSX.Element => {
  const { t } = useTranslation('metaSheet')
  const organisation = useBylineOrganisation()
  const creditsOrg = !!organisation && creditsOrganisation(credit)

  return (
    <LinkPillReadOnly
      field='byline'
      links={authors}
      Icon={UserPlusIcon}
      emptyLabel={creditsOrg ? '' : t('misc.noByline')}
      lead={creditsOrg ? organisation : undefined}
      hint={creditsOrg ? t('bylineCredit.authorsHint') : undefined}
    />
  )
}
